<template>
  <div>
  <el-form
      :inline="true"
      :model="addForm"
      ref="addForm"
      autocomplete="on"
      size="mini"
      label-width="80px">
    <el-row :gutter="24">

      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImage1" action="#">
            <i class="el-icon-upload" v-if="addForm.image_url1 == ''">
              <span class="fontStyle1">将附件照片第1页拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.image_url1 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
              <span class="fontStyle3">
              <i class="el-icon-zoom-in"
                 @click="openWin('../../static/typeImg.html?typeImage=' + addForm.image_url1)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(1)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
              </span>
            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImage2" action="#">
            <i class="el-icon-upload" v-if="addForm.image_url2 == ''">
              <span class="fontStyle1">将附件照片第2页拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.image_url2 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' + addForm.image_url2)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(2)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImage3" action="#">
            <i class="el-icon-upload" v-if="addForm.image_url3 == ''">
              <span class="fontStyle1">将附件照片第3页拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.image_url3 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' + addForm.image_url3)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(3)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
    </el-row>
    <el-row :gutter="24" style="padding-top: 10px; border-top: #3a8ee6 1px solid;">

      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImage4" action="#">
            <i class="el-icon-upload" v-if="addForm.image_url4 == ''">
              <span class="fontStyle1">将附件照片第4页拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.image_url4 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
              <span class="fontStyle3">
              <i class="el-icon-zoom-in"
                 @click="openWin('../../static/typeImg.html?typeImage=' + addForm.image_url4)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(4)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
              </span>
            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImage5" action="#">
            <i class="el-icon-upload" v-if="addForm.image_url5 == ''">
              <span class="fontStyle1">将附件照片第5页拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.image_url5 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' + addForm.image_url5)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(5)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
      <el-col :span="8">
        <el-form-item>
          <el-upload class="uploader" :auto-upload="false" :show-file-list="false" drag :on-change="UploadImage6" action="#">
            <i class="el-icon-upload" v-if="addForm.image_url6 == ''">
              <span class="fontStyle1">将附件照片第6页拖到此处，或
                <span class="fontStyle2">点击上传</span>
              </span>
            </i>
            <div class="uploaded" v-else :style="{'background-image': 'url(' + addForm.image_url6 + ')','width':'360px','height':'180px','background-size':'cover','margin-bottom':'200px'}">
<span class="fontStyle3">
                <i class="el-icon-zoom-in" @click="openWin('../../static/typeImg.html?typeImage=' + addForm.image_url6)">查看图片</i>
              <i class="el-icon-delete-solid" @click.stop="delImg(6)">删除图片</i>
              <i class="el-icon-refresh-right" slot="trigger">重新上传</i>
</span>

            </div>

          </el-upload>

        </el-form-item>


      </el-col>
    </el-row>
    <el-row :gutter="24">
      <el-col style="display:flex;flex-direction: row;justify-content: flex-end">
        <el-form-item>
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="save('addForm')">保存</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <!-- 全局遮罩 图片上传 -->
  <el-dialog :visible.sync="dialogVisible" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
    <div class="loading-overlay">
      <div class="loading-spinner" style="font-size:30px;font-weight: bold">
        <i class="el-icon-upload"></i>
        图片上传ing
        <i class="el-icon-loading"></i>
      </div>
    </div>
  </el-dialog>
  </div>
</template>

<script>
export default {
  name: "carOther",
  props: ['childData'],
  data() {
    return {
      newData: '',
      //车辆信息-大本
      dialogVisible: false,
      overlayClass: 'loading-overlay', // 遮罩元素的类名
      addForm:{
        image_url1:"",
        image_url2:"",
        image_url3:"",
        image_url4:"",
        image_url5:"",
        image_url6:"",
      },

    }
  },
  mounted() {
    if(this.childData){
      this.getCarInfo()
    }
  },
  methods:{
    close(){},
    save(formName){
      this.$refs[formName].validate((valid) => {
        if(!this.childData){
          this.$message.error('请先完成主车信息资料卡填写，再操作')
          return '';
        }
        if (valid) {
          let param={
            car_id:this.childData,
            type:4,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            image_url1:this.addForm.image_url1,
            image_url2:this.addForm.image_url2,
            image_url3:this.addForm.image_url3,
            image_url4:this.addForm.image_url4,
            image_url5:this.addForm.image_url5,
            image_url6:this.addForm.image_url6,
          };
          //console.log('save------',param);
          this.$axios.carMainUploadImg(param).then(res =>{
            if(res.code == 200){
              this.$message.success(res.msg)
              // this.$router.push('/carList')
            }else{
              this.$message.error(res.msg);
            }
          }).catch(function (error) {
            //console.log(error);
          })
        }
      });


    },
    updateChildData() {
      this.newData = '更新后的子组件数据';
      this.$emit('update-parent-data', this.newData);
    },
    delImg(type){
      switch (type){
        case 1:
          this.addForm.image_url1 = '';
          break;
        case 2:
          this.addForm.image_url2 = '';
          break;
        case 3:
          this.addForm.image_url3 = '';
          break;
        case 4:
          this.addForm.image_url4 = '';
          break;
        case 5:
          this.addForm.image_url5 = '';
          break;
        case 6:
          this.addForm.image_url6 = '';
          break;
      }

    },
    //上传图片的方法
    UploadImage1(file) {
      this.addForm.image_url1 = URL.createObjectURL(file.raw);
      //console.log('file', file)
      this.commonUploadFuc(file,1)
    },
    UploadImage2(file) {
      this.addForm.image_url2 = URL.createObjectURL(file.raw);
      //console.log('file', file)
      this.commonUploadFuc(file,2)
    },
    UploadImage3(file) {
      this.addForm.image_url3 = URL.createObjectURL(file.raw);
      //console.log('file', file)
      this.commonUploadFuc(file,3)
    },
    UploadImage4(file) {
      this.addForm.image_url4 = URL.createObjectURL(file.raw);
      //console.log('file', file)
      this.commonUploadFuc(file,4)
    },
    UploadImage5(file) {
      this.addForm.image_url5 = URL.createObjectURL(file.raw);
      //console.log('file', file)
      this.commonUploadFuc(file,5)
    },
    UploadImage6(file) {
      this.addForm.image_url6 = URL.createObjectURL(file.raw);
      //console.log('file', file)
      this.commonUploadFuc(file,6)
    },
    commonUploadFuc(file,type){
      this.dialogVisible = true;
      let payFd = new FormData()
      payFd.append('file', file.raw)
      payFd.append('img_type', 15)
      payFd.append('company_id', sessionStorage.getItem('company_id'))
      payFd.append('access_token', sessionStorage.getItem('token'))
      this.$axios.carUploadImage(payFd).then(res => {
        if (res.code == 200) {
          //console.log('oss-src',res.data.src)
          switch (type){
            case 1:
              this.addForm.image_url1 = res.data.src;
              break;
            case 2:
              this.addForm.image_url2 = res.data.src;
              break;
            case 3:
              this.addForm.image_url3 = res.data.src;
              break;
            case 4:
              this.addForm.image_url4 = res.data.src;
              break;
            case 5:
              this.addForm.image_url5 = res.data.src;
              break;
            case 6:
              this.addForm.image_url6 = res.data.src;
              break;
          }
          this.dialogVisible = false;
          this.$message.success(res.msg)
        }else{
          this.$message.error(res.msg)
        }
      }).catch(error => console.log('UploadImage-error',error))

    },
    openWin(url) {
      var name;                           //网页名称，可为空;
      var iWidth = 500;                         //弹出窗口的宽度;
      var iHeight = 570;                        //弹出窗口的高度;
      //window.screen.height获得屏幕的高，window.screen.width获得屏幕的宽
      var iTop = (window.screen.height - 30 - iHeight) / 2;       //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 10 - iWidth) / 2;        //获得窗口的水平位置;
      window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizable=no,location=no,status=no');
    },
    //获取车辆档案信息
    getCarInfo(){
      let _this=this;
      let param = {
        id:this.childData,
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      };
      this.$axios.carInfo(param).then(res =>{
        if(res.code == 200){
          const attachment=res.data.attachment
          attachment.forEach(function(item,index) {
            //console.log('look-imageurl'+(index+1),item.image_url);
            switch (index+1){
              case 1:
                _this.addForm.image_url1 = item.image_url;
                break;
              case 2:
                _this.addForm.image_url2 = item.image_url;
                break;
              case 3:
                _this.addForm.image_url3 = item.image_url;
                break;
              case 4:
                _this.addForm.image_url4 = item.image_url;
                break;
              case 5:
                _this.addForm.image_url5 = item.image_url;
                break;
              case 6:
                _this.addForm.image_url6 = item.image_url;
                break;
            }
          });
        }else{
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>

<style scoped>

.fontStyle1{
  display: block;
  font-size:14px;
  color: #606266;
}
.fontStyle2,.fontStyle3{
  font-size:14px;
  color: #3a8ee6;
}
.fontStyle3{
  font-size:22px;
  color: #999;
  position: absolute;
  bottom: 1px;
  right: 1px;
}
</style>


// WEBPACK FOOTER //
// src/view/common/carOther.vue